// src/packages/chubb/pa/chubb_pa_series_d_2025/ChubbPASeriesDDetails.jsx
import React from "react";
import "./chubb_pa_series_d.css";

/**
 * Chubb — PA Series D (Plan 1–8 + Kid)
 * Zero-index safe: ไม่มี {index} ใน JSX และคีย์ map มาจากข้อมูลจริง
 * เติมตัวเลขจากใบปลิว Series D ลงในอาร์เรย์ด้านล่างได้ทันที
 */

const fmt = (x) =>
  x === null || x === undefined ? "—" : typeof x === "number" ? x.toLocaleString() : x;

const PLANS = ["แผน 1","แผน 2","แผน 3","แผน 4","แผน 5","แผน 6","แผน 7","แผน 8","บุตร Kid"];

// ===== ผลประโยชน์ต่อแผน (ใส่ค่าตามตารางบนใบปลิว) =====
const benefits = [
  { key: "life",    name: "1. อุบัติเหตุทั่วไป (ชีวิต/สูญเสียอวัยวะ/ทุพพลภาพถาวร)", vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "murder",  name: "1.2 ฆาตกรรม/ทำร้ายร่างกาย",                        vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "moto",    name: "1.3 อุบัติเหตุรถจักรยานยนต์",                       vals: [50000,100000,150000,250000,350000,500000,1000000,1500000,25000] },
  { key: "terror",  name: "1.4 การก่อการร้าย",                                  vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "holiday", name: "1.5/1.6 วันหยุด/พาหนะสาธารณะ (เพิ่มทุน)",           vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "funeral", name: "2. ค่าปลงศพ (เหตุอุบัติเหตุ)",                      vals: [20000,20000,20000,20000,20000,20000,20000,20000,5000] },
  { key: "med",     name: "3. ค่ารักษาพยาบาลต่อครั้ง (รวมมอเตอร์ไซค์)",        vals: [500,1000,1500,2000,2500,3000,3500,4000,500] }, // หน่วยเป็นบาท ให้ปรับตามตารางจริง
  { key: "hap",     name: "5–6 HAP/ICU เพิ่มเติม (ถ้ามีในชุดแผน)",              vals: [/* กรอกค่า หรือปล่อยว่าง */] },
  { key: "edu",     name: "10. กองทุนการศึกษา บุตร (ถ้ามี)",                    vals: [/* กรอกค่า หรือปล่อยว่าง */] },
];

// ===== เบี้ยรายปี (รวมอากร/แสตมป์) — PA1 / PA2 / PA3 (Series D มีตารางย่อยหลายชุด) =====
const premiums = {
  // จากแถบสีส้มบล็อกแรกในใบปลิว
  PA1: [
    { key: "main",   label: "ผู้เอาประกันหลัก (PA1)",                     vals: [1380,2450,3080,3780,4280,5180,6780,8380,null] },
    { key: "spouse", label: "ผู้เอาประกัน + คู่สมรส (PA1)",                 vals: [2680,4480,5480,6980,8180,9680,11880,13980,null] },
    { key: "kids2",  label: "ผู้เอาประกัน + บุตร ≤ 2 คน (PA1)",             vals: [3480,5980,6580,7280,7780,8680,10280,11180,null] },
    { key: "kids3",  label: "ผู้เอาประกัน + บุตร ≤ 3 คน (PA1)",             vals: [6180,8380,9480,10480,11280,12580,15380,18480,null] },
  ],
  // บล็อกที่สอง (ทพ.และค่ารักษาสูงขึ้น)
  PA2: [
    { key: "main",   label: "ผู้เอาประกันหลัก (PA2)",                     vals: [1680,2980,3680,4580,5180,6280,8280,10280,null] },
    { key: "spouse", label: "ผู้เอาประกัน + คู่สมรส (PA2)",                 vals: [3280,5750,7180,8580,9680,11280,13680,16980,null] },
    { key: "kids2",  label: "ผู้เอาประกัน + บุตร ≤ 2 คน (PA2)",             vals: [5180,6480,7180,8080,8680,9780,11780,13780,null] },
    { key: "kids3",  label: "ผู้เอาประกัน + บุตร ≤ 3 คน (PA2)",             vals: [6780,9280,10580,12380,13580,15680,19580,23480,null] },
  ],
  // บล็อกที่สาม (แถบส้มด้านล่างสุด)
  PA3: [
    { key: "main",   label: "ผู้เอาประกันหลัก (PA3)",                     vals: [1480,2580,3180,3980,4580,5580,7580,9580,null] },
    { key: "spouse", label: "ผู้เอาประกัน + คู่สมรส (PA3)",                 vals: [2880,4980,5980,7480,8680,10380,13180,17380,null] },
    { key: "kids2",  label: "ผู้เอาประกัน + บุตร ≤ 2 คน (PA3)",             vals: [4080,5680,6180,6880,7480,8380,10380,12580,null] },
    { key: "kids3",  label: "ผู้เอาประกัน + บุตร ≤ 3 คน (PA3)",             vals: [5680,8080,9680,11880,13680,16180,20180,24580,null] },
  ],
};

export default function ChubbPASeriesDDetails({ onQuote }) {
  return (
    <div className="pkg-detail chubb-pa-d">
      <h2>Chubb PA Series D — แผน 1–8 + Kid</h2>
      <p className="pkg-note">
        อายุรับ 15–70 ปี ต่ออายุได้ถึง 75 ปี • บุตร 6 เดือน–23 ปี (ตามเงื่อนไข) •
        มีชุดเบี้ยให้เลือกหลายกลุ่ม (PA1/PA2/PA3) • เบี้ยรวมอากรแสตมป์
      </p>

      {/* Benefits */}
      <h3 className="pkg-section">ผลประโยชน์ต่อแผน</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th className="pkg-left">ความคุ้มครอง</th>
            {PLANS.map((p) => <th key={`plan-${p}`}>{p}</th>)}
          </tr>
        </thead>
        <tbody>
          {benefits.map((b) => (
            <tr key={`bf-${b.key}`}>
              <td className="pkg-left">{b.name}</td>
              {(b.vals || []).map((v, i) => <td key={`bf-${b.key}-${i}`}>{fmt(v)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Premium tables */}
      {(["PA1","PA2","PA3"]).map((tier) => (
        <div className="pkg-table-wrap" key={`tier-${tier}`}>
          <h3 className="pkg-section">เบี้ยรายปี ({tier})</h3>
          <table className="pkg-table">
            <thead>
              <tr>
                <th className="pkg-left">รูปแบบผู้เอาประกัน</th>
                {PLANS.map((p) => <th key={`${tier}-h-${p}`}>{p}</th>)}
              </tr>
            </thead>
            <tbody>
              {(premiums[tier] || []).map((row) => (
                <tr key={`${tier}-${row.key}`}>
                  <td className="pkg-left">{row.label}</td>
                  {(row.vals || []).map((v, i) => (
                    <td key={`${tier}-${row.key}-${i}`}>{fmt(v)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      <ul className="pkg-bullets">
        <li>Kid = บุตรอายุ 6 เดือน–23 ปี (ตามเงื่อนไขบริษัท)</li>
        <li>ตรวจสอบข้อยกเว้นและอาชีพที่ไม่รับก่อนเสนอขาย</li>
      </ul>

      <div className="pkg-foot">
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา Chubb PA Series D">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
